import React from 'react';
import { useAgentConfig } from '../contexts/AgentConfigContext';
import { useDarkMode } from '../contexts/DarkModeContext';
import Dropdown from '../common_jsx/Dropdown';
import { AlertTriangle, Check } from 'lucide-react';

const AgentSelector = () => {
  const { config, selectedAgentIndex, selectAgent, availableAgents, isLoading, error } = useAgentConfig();
  const { isDarkMode } = useDarkMode();

  // Show loading state
  if (isLoading) {
    return (
      <div className="agent-selector">
        <button 
          className={`px-4 py-2 rounded-xl border font-medium text-sm ${
            isDarkMode 
              ? 'bg-slate-800 border-slate-700 text-slate-400' 
              : 'bg-slate-100 border-slate-300 text-slate-600'
          }`}
          disabled
        >
          <span className="inline-block w-4 h-4 border-2 border-t-transparent rounded-full animate-spin mr-2" 
            style={{ borderColor: isDarkMode ? '#64748b' : '#94a3b8', borderTopColor: 'transparent' }}
          ></span>
          Loading agents...
        </button>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="agent-selector">
        <button 
          className={`px-4 py-2 rounded-xl border font-medium text-sm ${
            isDarkMode 
              ? 'bg-red-900/20 border-red-800/40 text-red-400' 
              : 'bg-red-50 border-red-300 text-red-600'
          }`}
          disabled
        >
          <AlertTriangle className="w-4 h-4 mr-2 inline-block" />
          Error loading agents
        </button>
      </div>
    );
  }

  const dropdownItems = availableAgents.map((agent, index) => ({
    name: agent.name,
    onClick: () => selectAgent(index),
    isSelected: selectedAgentIndex === index,
    icon: selectedAgentIndex === index ? (
      <div 
        className="w-[18px] h-[18px] rounded-full flex items-center justify-center mr-2"
        style={{
          background: isDarkMode ? '#0ea5e9' : '#0ea5e9',
        }}
      >
        <Check className="w-3.5 h-3.5" style={{ color: 'white', strokeWidth: 3 }} />
      </div>
    ) : (
      <div 
        className="w-[18px] h-[18px] rounded-full mr-2"
        style={{
          border: isDarkMode ? '2px solid rgba(148, 163, 184, 0.4)' : '2px solid rgba(203, 213, 225, 0.6)',
        }}
      ></div>
    )
  }));

  const heading = {
    icon: null,
    name: config.name
  };

  const buttonStyle = {
    background: isDarkMode ? 'rgba(30, 41, 59, 0.6)' : 'rgba(248, 250, 252, 0.9)',
    border: isDarkMode ? '1px solid rgba(51, 65, 85, 0.6)' : '1px solid rgba(226, 232, 240, 0.8)',
    borderRadius: '12px',
    padding: '10px 16px',
    fontSize: '14px',
    fontWeight: '500',
    color: isDarkMode ? '#e2e8f0' : '#334155',
    boxShadow: isDarkMode ? '0 2px 8px rgba(0, 0, 0, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease',
  };

  return (
    <div className="agent-selector">
      <Dropdown
        heading={heading}
        items={dropdownItems}
        type="button"
        customStyle={buttonStyle}
      />
    </div>
  );
};

export default AgentSelector;